import React from 'react';
import AllRoute from '../router'
import {ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import LanguageSwitcher from '../../components/LanguageSwitcher/LanguageSwitcher';


const App = () => { 

  return (
    <div className="App" id='scrool'>
          <AllRoute/>
          <LanguageSwitcher/>
          <ToastContainer/>
    </div>
  );
}

export default App;
